/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { billing_InvoiceLineItemResponse } from './billing_InvoiceLineItemResponse';
import type { billing_InvoiceSplit } from './billing_InvoiceSplit';
export type billing_InvoiceResponse = {
    billing_period_month?: number;
    billing_period_year?: number;
    contract_id?: string;
    readonly created_at?: string;
    due_date?: string;
    readonly id?: string;
    readonly invoice_number?: string;
    line_items?: Array<billing_InvoiceLineItemResponse>;
    notes?: string;
    /**
     * PaidAmount in minor currency units; reconciled via invoice_splits.paid_amount and derived from payment_applications
     */
    paid_amount?: number;
    readonly paid_at?: string;
    payment_reference?: string;
    /**
     * RoundingParentsAmount is the parent-side rounding step in minor units (Rappen),
     * snapshotted from the period-start tariff version at generation time (issue #720).
     * Omitted on legacy invoices that predate the snapshot.
     */
    rounding_parents_amount?: number;
    /**
     * RoundingParentsEnabled is the parent-side rounding toggle snapshotted from the
     * period-start tariff version at generation time (issue #720). Omitted on legacy
     * invoices that predate the snapshot.
     */
    rounding_parents_enabled?: boolean;
    /**
     * RoundingSubsidyAmount is the subsidy-side rounding step in minor units (Rappen),
     * snapshotted from the period-start tariff version at generation time (issue #720).
     * Omitted on legacy invoices that predate the snapshot.
     */
    rounding_subsidy_amount?: number;
    /**
     * RoundingSubsidyEnabled is the subsidy-side rounding toggle snapshotted from the
     * period-start tariff version at generation time (issue #720). Omitted on legacy
     * invoices that predate the snapshot.
     */
    rounding_subsidy_enabled?: boolean;
    splits?: Array<billing_InvoiceSplit>;
    status?: billing_InvoiceResponse.status;
    /**
     * SubtotalAmount in minor currency units (e.g., 50000 = 500.00 in major units)
     */
    subtotal_amount?: number;
    /**
     * TotalAmount in minor currency units (e.g., 45000 = 450.00 in major units)
     */
    total_amount?: number;
    readonly updated_at?: string;
};
export namespace billing_InvoiceResponse {
    export enum status {
        DRAFT = 'draft',
        FINALIZED = 'finalized',
        SENT = 'sent',
        PAID = 'paid',
        PARTIAL = 'partial',
        OVERDUE = 'overdue',
        CANCELLED = 'cancelled',
        CREDITED = 'credited',
    }
}

